import { Component, inject, model } from '@angular/core';

import { BaseComponent, BaseEditFormModalComponent, ModalService } from 'tms-lib';
import { AddressDetails, AddressService, CustomerAddressEdit } from 'tms-web-shared';
import { AddressDetailsComponent } from '../address-details/address-details.component';

@Component({
  selector: 'app-address-create-modal',
  templateUrl: './address-create-modal.component.html',
  styleUrl: './address-create-modal.component.scss',
  imports: [BaseEditFormModalComponent, AddressDetailsComponent],
})
export class AddressCreateModalComponent extends BaseComponent {
  protected readonly addressService = inject(AddressService);
  private readonly modalService = inject(ModalService);

  // A model, not an input: SearchModalComponent.create() opens this window and sets the id on it.
  public readonly id = model<string>();

  saved(model: AddressDetails) {
    const customerAddress = { addressId: model.id, customerId: this.id() } as CustomerAddressEdit;
    this.modalService.close(customerAddress);
  }
}
